import { render, staticRenderFns } from "./selectPolicy.vue?vue&type=template&id=40058e7c&scoped=true&"
import script from "./selectPolicy.vue?vue&type=script&lang=js&"
export * from "./selectPolicy.vue?vue&type=script&lang=js&"
import style0 from "./selectPolicy.vue?vue&type=style&index=0&id=40058e7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40058e7c",
  null
  
)

export default component.exports